import keyMirror from 'keymirror';

export default keyMirror({
  SESSION_STARTED: null,
  SESSION_CANCELED: null,
  SESSION_FAILED: null,
  STRIPE_WAS_LOADED: null,
  POYNT_WAS_LOADED: null,
  AVAILABILITY_WAS_CHECKED: null,
  APPLE_PAY_IS_AVAILABLE: null,
  PAYMENT_REQUEST_IS_AVAILABLE: null,
  PAYMENT_REQUEST_BUTTON_CLICKED: null
});
